import { render, staticRenderFns } from "./sub-product-add.vue?vue&type=template&id=7482a33f&"
import script from "./sub-product-add.vue?vue&type=script&lang=js&"
export * from "./sub-product-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports